import React, {Component} from 'react';
import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';

import MenuComponent2 from './MenuComponent2';
import ShippingCalendar from './ShippingCalendar';
import ImageUploader from './ImageUploader';
import CountryMappngList from './CountryMappngList';
import AuthenticationService from '../services/AuthenticationService';

class SettingsByService extends Component{
    constructor() {
        super();
        this.state = {
        };
    };

    componentDidMount () {
    }


    render(){
        if(!AuthenticationService.isService()){
            return (<div>Unauthorized access.</div>);
        }
        
        return (
            <div>
                <MenuComponent2 />
                <br/>
                <br/>
                <div className="row">
                    <div className="col-12">
                        <ImageUploader />
                    </div>
                </div>
            </div>
        );
    }
}

export default SettingsByService;
